import { FC } from "react";
import { LeftRailNavigationFlatProps } from "./LeftRailNavigationFlat";
import { Select } from "@/components/Select";
import { Dropdown as DropdownType } from "@/types/General/Dropdown";

const LeftRailNavigationFlatMobile: FC<
  Omit<LeftRailNavigationFlatProps, "children"> & {
    initialActiveItemIndex: number;
  }
> = ({ navItems, initialActiveItemIndex, onMobileNavChange }) => {
  const dropdownOptions = navItems.map((item) => ({
    label: item.name,
    value: item.href,
    ...item,
  }));
  const initialValue = dropdownOptions[initialActiveItemIndex] ?? null;

  return (
    <Select
      variant="large rectangular"
      options={dropdownOptions}
      defaultValue={initialValue}
      onChange={(value: DropdownType | null) =>
        onMobileNavChange?.(value?.value || "")
      }
    />
  );
};

export default LeftRailNavigationFlatMobile;
